import { render } from "./mped-department-tree-component.vue?vue&type=template&id=4d389d8c"
import script from "./mped-department-tree-component.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-department-tree-component.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/calculation/component/mped-department-tree-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d389d8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d389d8c', __exports__)) {
    api.reload('4d389d8c', __exports__)
  }
  
  module.hot.accept("./mped-department-tree-component.vue?vue&type=template&id=4d389d8c", () => {
    api.rerender('4d389d8c', render)
  })

}


export default __exports__